"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const alert_box_1 = require("../../widgets/alert_box");
const form_for_1 = require("../../widgets/form_for");
let done = false;
const formParams = {
    token: "",
    email: "",
    password: "",
    passwordConfirmation: "",
    passwordError: null,
};
function renderChoosePassword() {
    return [
        (0, mithril_1.default)(".content", (0, mithril_1.default)("h2", "Réinitialiser votre mot de passe"), (0, mithril_1.default)("p", "Merci de choisir un nouveau mot de passe (minimum 8 caractères)")),
        renderFormPassword()
    ];
}
function renderPasswordChanged() {
    return (0, mithril_1.default)("div", "Votre mot de passe a été mis à jour", (0, mithril_1.default)("br"), (0, mithril_1.default)("a", { href: "/" }, "Cliquez ici pour vous connecter"));
}
function checkPasswordAndUpdate() {
    if (formParams.password !== formParams.passwordConfirmation) {
        formParams.passwordError = "Les mots de passes ne sont pas identiques";
        return;
    }
    if (formParams.password.length < 8) {
        formParams.passwordError = "Votre mot de passe doit comporter au moins 8 caractères!";
        return;
    }
    app_1.App.patch("/password/change", {
        token: formParams.token,
        email: formParams.email,
        password: formParams.password
    }).then((_x) => {
        done = true;
    }).catch(() => {
        formParams.passwordError = "Erreur imprévue du serveur. Veuillez rééssayer dans quelques minutes";
    });
}
function renderFormPassword() {
    return (0, mithril_1.default)(".content", (0, mithril_1.default)("form", (formParams.passwordError ? (0, alert_box_1.alertBox)({
        content: formParams.passwordError,
        level: "danger"
    }) : undefined), (0, form_for_1.columns)((0, form_for_1.field)("Votre mot de passe", "password", "password", formParams, { placeholder: "password" }), (0, form_for_1.field)("Repetez votre mot de passe", "passwordConfirmation", "password", formParams, { placeholder: "password" })), (0, mithril_1.default)("button.button.is-success", { type: "submit", onclick: (evt) => {
            evt.preventDefault();
            checkPasswordAndUpdate();
        } }, "Envoyer")));
}
exports.ChangePasswordPage = {
    oncreate() {
        let email = mithril_1.default.route.param('email');
        let token = mithril_1.default.route.param('token');
        formParams.token = token;
        formParams.email = email;
    },
    view() {
        return (0, mithril_1.default)(".sign-in", { style: "padding-top: 5em;" }, (0, mithril_1.default)("nav.panel.container", { style: "background-color: white; padding: 1em; border-radius: 1em;" }, done ? renderPasswordChanged() : renderChoosePassword()));
    }
};
